import { useContext, useCallback, useMemo } from 'react';
import { AnalyticsContext } from './analytics-context';
import { buildSendEvent } from './utils/build-send-event';
import { useDebugConsole } from './utils/use-debug-console';
import { buildEventBoundary } from './build-event-boundary';
var eventStyle = 'color:darkgreen;font-weight:bold';
var boundaryStyle = 'color:darkorange;font-weight:bold';
export var useSendEvent = function useSendEvent() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    boundaryName = _ref.name,
    boundaryData = _ref.data;
  var _useDebugConsole = useDebugConsole(),
    logger = _useDebugConsole.logger;
  var _useContext = useContext(AnalyticsContext),
    sendEvent = _useContext.sendEvent;
  var isAugmented = boundaryName || boundaryData && Object.keys(boundaryData).length > 0;
  var augmentedSendEvent = useCallback((eventName, eventData) => {
    if (isAugmented) {
      logger.info("%cfe-co-analytics: useSendEvent: sending event %c".concat(eventName, "%c, payload ").concat(JSON.stringify(eventData), " augmented with %c").concat(boundaryName, "%c").concat(boundaryData ? " ".concat(boundaryName ? 'and ' : '', "payload") : ''), '', eventStyle, '', boundaryName ? boundaryStyle : '', '', boundaryData);
    } else {
      logger.info("%cfe-co-analytics: useSendEvent: sending event %c".concat(eventName, "%c").concat(eventData ? ' with payload' : ''), '', eventStyle, '', eventData);
    }
    return buildSendEvent(sendEvent)(boundaryName, boundaryData)(eventName, eventData);
  }, [boundaryName, boundaryData, sendEvent, logger, isAugmented]);
  var EventBoundary = useMemo(() => buildEventBoundary({
    name: boundaryName,
    data: boundaryData
  }), [boundaryName, boundaryData]);
  return {
    sendEvent: augmentedSendEvent,
    EventBoundary
  };
};